export default [
  {
    id: '1',
    icon: 'dashboard',
    name: 'Dashboard',
    route: `${process.env.PUBLIC_URL}/`,
  },
  {
    id: '2',
    bpid: '1',
    name: 'Administração',
    icon: 'api',
  },
  {
    id: '21',
    bpid: '2',
    mpid: '2',
    name: 'Perfis',
    icon: 'team',
    route: '/roles',
  },
  {
    id: '21',
    mpid: '-1',
    bpid: '21',
    name: 'Novo Perfil',
    route: '/roles/new',
  },
  {
    id: '22',
    bpid: '2',
    mpid: '2',
    name: 'Permissões de usuário',
    icon: 'unlock',
    route: '/permissions',
  },
  {
    id: '3',
    bpid: '1',
    name: 'Perfil',
    icon: 'user',
    route: '/profile',
  },
  {
    id: '4',
    bpid: '1',
    name: 'Gestão de Pessoas',
    icon: 'team',
  },
  {
    id: '41',
    bpid: '4',
    mpid: '4',
    name: 'Colaboradores',
    icon: 'switcher',
    route: '/employees',
  },
  {
    id: '41',
    mpid: '-1',
    bpid: '41',
    name: 'Novo Colaborador',
    route: '/employees/new',
  },
  {
    id: '42',
    bpid: '4',
    mpid: '4',
    name: 'Férias',
    icon: 'rocket',
    route: '/vacation',
  },
  {
    id: '43',
    bpid: '4',
    mpid: '4',
    name: 'Atestados',
    icon: 'switcher',
    route: '/medical-certificate',
  },
  {
    id: '44',
    bpid: '4',
    mpid: '4',
    name: 'Entrevistas',
    icon: 'schedule',
    route: '/interviews',
  },
  {
    id: '44',
    mpid: '-1',
    bpid: '44',
    name: 'Nova Entrevista',
    route: '/interviews/new',
  },
  {
    id: '5',
    bpid: '1',
    name: 'Projetos',
    icon: 'copy',
    route: '/projects',
  },
  {
    id: '5',
    mpid: '-1',
    bpid: '5',
    name: 'Novo Projeto',
    route: '/projects/new',
  },
  {
    id: '6',
    bpid: '1',
    name: 'Gestão de Carreiras',
    icon: 'solution',
  },
  {
    id: '61',
    bpid: '6',
    mpid: '6',
    name: 'Cargos/Níveis',
    icon: 'switcher',
    route: '/levels',
  },
  {
    id: '61',
    mpid: '-1',
    bpid: '61',
    name: 'Novo Cargo',
    route: '/levels/new',
  },
  {
    id: '62',
    bpid: '6',
    mpid: '6',
    name: 'Carreiras',
    icon: 'switcher',
    route: '/careers',
  },
  {
    id: '63',
    bpid: '6',
    mpid: '6',
    name: 'Requisições',
    icon: 'switcher',
    route: '/requests',
  },
  {
    id: '64',
    bpid: '6',
    mpid: '6',
    name: 'Badges',
    icon: 'switcher',
    route: '/badges',
  },
  {
    id: '64',
    mpid: '-1',
    bpid: '64',
    name: 'Nova Badge',
    route: '/badges/new',
  },
  {
    id: '7',
    bpid: '1',
    name: 'Gestao de Ponto',
    icon: 'clock-circle-o',
    route: '/time',
  },
];



// WEBPACK FOOTER //
// ./src/mock/menu.js